export enum MerchantSetupProvinceEnum {
  'Eastern Cape' = 'EC',
  'Free State' = 'FS',
  'Gauteng' = 'GT',
  'KwaZulu-Natal' = 'NL',
  'Limpopo' = 'LP',
  'Mpumalanga' = 'MP',
  'Northern Cape' = 'NC',
  'North West' = 'NW',
  'Western Cape' = 'WC'
}

export namespace MerchantSetupProvinceEnum {
  export function values() {
    return Object.keys(MerchantSetupProvinceEnum).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
